module.exports = __webpack_public_path__ + "static/media/26.5b4536c2.jpg";